import {  } from "helpers/url_helper";
import {
  POST_CHECKOUT,
  POST_CHECKOUT_SUCCESS,
  POST_CHECKOUT_FAIL,
} from "./actionTypes";

export const postCheckout = (plan) => ({
  type: POST_CHECKOUT,
  payload: { plan },
})

export const postCheckoutSuccess = (data) => ({
  type: POST_CHECKOUT_SUCCESS,
  payload: data,
})

export const postCheckoutFail = error => ({
  type: POST_CHECKOUT_FAIL,
  payload: error,
})
